'use client'

import { default as NextLink } from 'next/link'
import { Link as ChakraLink } from '@/components/Chakra'
import { LinkProps } from '@chakra-ui/next-js'

type Props = {
  children: React.ReactNode
  href: string
  prefetch?: boolean
  isTextLink?: boolean
} & LinkProps

export const Link = ({ prefetch = false, isTextLink = false, ...props }: Props) => {
  return (
    <NextLink href={props.href} prefetch={prefetch} target={props.target}>
      <ChakraLink as={'span'} className={isTextLink ? 'text-link' : ''} {...props}>
        {props.children}
      </ChakraLink>
    </NextLink>
  )
}
